<template>
  <p class='reading-time'>{{ totalReadingTime }} min read</p>
</template>

<script>
export default {
  data() {
    return {
      totalReadingTime: 0,
    };
  },
  mounted() {
    this.calculateReadingTime();
  },
  methods: {
    calculateReadingTime() {
      const elements = document.querySelectorAll('.wysiwyg');
      let totalWords = 0;
      elements.forEach(element => {
        totalWords += this.getWordCount(element.innerText);
      });
      const wordsPerMinute = 100; // You can adjust this value as needed
      this.totalReadingTime = (totalWords / wordsPerMinute).toFixed(2);
    },
    getWordCount(text) {
      return text.split(/\s+/).filter(word => word.length > 0).length;
    },
  },
};
</script>

<style scoped>
/* Add any styles you need here */
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/ReadingTime.vue